import dynamic from 'next/dynamic';
import { createPortal } from 'react-dom';
import A from './components/A';
import css from './index.module.scss';
import MenuTree from './components/MenuTree';
import MenuNav from './components/MenuNav';
import EfScrollAni from '@/efscrollani';
import { useGlobal } from '@/utils/useGlobal';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function Vanlife() {
    const { useState, useEffect } = useGlobal();
    const [open, setOpen] = useState(false);
    const [isClient, setIsClient] = useState(false);

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div className={`vanlife ${css['vanlife']}`}>
            <div className="ef-box">
                <main className="main-content">
                    <A />
                    {isClient && createPortal(<MenuNav open={open} callback={setOpen} />, document.body)}
                    <IndexDynamic open={open} callback={setOpen} />
                </main>
                <MenuTree open={open} callback={setOpen} />
            </div>
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
